import { LogIn, LogOut as LogOutIcon } from 'react-feather';
import { Link } from 'react-router-dom';
import { getProfileList, profileList } from '../../../data/layout/Header';
import { useAppDispatch, useAppSelector } from '../../../reduxToolkit/hooks';
import { logout } from '../../../reduxToolkit/reducers/layout/authSlice';
import { dynamicImage } from '../../../utils';
import { routes } from '../../../routers/routes';
import { LogOut } from '../../../constants';
import SvgIcon from '../../../coreComponents/SvgIcon';
import { Image } from '../../../coreComponents/Image';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useGetUserProfileDataQuery } from '../../../reduxToolkit/reducers/usersSlice';

interface ProfileProps {
  setOpenLogoutNotification: (open: boolean) => void;
}

const Profile: React.FC<ProfileProps> = ({ setOpenLogoutNotification }) => {
  const { email } = useAppSelector((state) => state.auth);
  const [userAvatar, setUserAvatar] = useState('/assets/images/avtar/default-user.png');
  const { data: profileData, isError, isSuccess } = useGetUserProfileDataQuery({ email });
  const { t } = useTranslation();
  useEffect(() => {
    if (profileData?.user.photo) {
      const hasPhoto =
        profileData.user.photo &&
        typeof profileData.user.photo === 'string' &&
        profileData.user.photo.trim() !== '' &&
        !profileData.user.photo.includes('default-user.png');
      setUserAvatar(
        hasPhoto
          ? `${process.env.REACT_APP_BACKEND_STATIC}/userPics/${profileData.user.photo}`
          : '/assets/images/avtar/default-user.png',
      );
    }
  }, [profileData]);

  return (
    <li className="profile-nav onhover-dropdown p-0 m-0">
      <div className="d-flex profile-media align-items-center">
        <Image className="b-r-6 img-40 ratio ratio-1x1" src={userAvatar} alt="profile" />
        <div className="d-flex flex-grow-1 flex-row">
          <span>{email}</span>
          <p className="mb-0">
            <SvgIcon iconId="header-arrow-down" />
          </p>
        </div>
      </div>
      <ul className="profile-dropdown onhover-show-div">
        {getProfileList(t).map((item) => (
          <li key={item.id}>
            <Link to={item.link}>
              {item.icon}
              <span>{item.text} </span>
            </Link>
          </li>
        ))}
        <li>
          <Button outline={true} onClick={() => setOpenLogoutNotification(true)}>
            <LogOutIcon />
            <span>{t('profile.logout')}</span>
          </Button>
        </li>
      </ul>
    </li>
  );
};
export default Profile;
